module.exports = __webpack_public_path__ + "icons.962a1bf31c081691065f.svg";


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/assets/semantic/themes/default/assets/fonts/icons.svg
// module id = ../../../../../src/assets/semantic/themes/default/assets/fonts/icons.svg
// module chunks = styles